var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8714_10391)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 152,
    height: 152,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.605 129V119.13H50.047V127.796H54.835V129H48.605ZM59.0339 129.098C58.3619 129.098 57.7693 128.953 57.2559 128.664C56.7519 128.375 56.3599 127.964 56.0799 127.432C55.8093 126.891 55.6739 126.265 55.6739 125.556C55.6739 124.837 55.8093 124.212 56.0799 123.68C56.3599 123.139 56.7519 122.723 57.2559 122.434C57.7693 122.145 58.3619 122 59.0339 122C59.7059 122 60.2939 122.145 60.7979 122.434C61.3113 122.723 61.7033 123.139 61.9739 123.68C62.2539 124.212 62.3939 124.837 62.3939 125.556C62.3939 126.265 62.2539 126.891 61.9739 127.432C61.7033 127.964 61.3113 128.375 60.7979 128.664C60.2939 128.953 59.7059 129.098 59.0339 129.098ZM59.0339 127.978C59.6593 127.978 60.1353 127.773 60.4619 127.362C60.7979 126.951 60.9659 126.349 60.9659 125.556C60.9659 124.772 60.7979 124.175 60.4619 123.764C60.1259 123.344 59.6499 123.134 59.0339 123.134C58.4179 123.134 57.9419 123.344 57.6059 123.764C57.2699 124.175 57.1019 124.772 57.1019 125.556C57.1019 126.349 57.2653 126.951 57.5919 127.362C57.9279 127.773 58.4086 127.978 59.0339 127.978ZM66.8243 122C67.7389 122 68.4156 122.229 68.8543 122.686C69.3023 123.143 69.5263 123.839 69.5263 124.772V129H68.1683V127.866C67.9909 128.267 67.7249 128.575 67.3703 128.79C67.0249 128.995 66.6189 129.098 66.1523 129.098C65.7043 129.098 65.2936 129.009 64.9203 128.832C64.5469 128.645 64.2529 128.389 64.0383 128.062C63.8329 127.735 63.7303 127.371 63.7303 126.97C63.7303 126.475 63.8563 126.088 64.1083 125.808C64.3696 125.519 64.7943 125.313 65.3823 125.192C65.9796 125.071 66.7963 125.01 67.8323 125.01H68.1543V124.604C68.1543 124.081 68.0423 123.703 67.8183 123.47C67.6036 123.237 67.2489 123.12 66.7543 123.12C65.9796 123.12 65.2049 123.358 64.4303 123.834L64.0103 122.84C64.3743 122.588 64.8129 122.387 65.3263 122.238C65.8489 122.079 66.3483 122 66.8243 122ZM66.4043 128.048C66.9176 128.048 67.3376 127.875 67.6643 127.53C67.9909 127.175 68.1543 126.723 68.1543 126.172V125.808H67.9023C67.1743 125.808 66.6143 125.841 66.2223 125.906C65.8303 125.971 65.5503 126.083 65.3823 126.242C65.2143 126.391 65.1303 126.611 65.1303 126.9C65.1303 127.227 65.2469 127.502 65.4803 127.726C65.7229 127.941 66.0309 128.048 66.4043 128.048ZM77.7605 119.13V129H76.3605V127.824C76.1551 128.235 75.8565 128.552 75.4645 128.776C75.0725 128.991 74.6198 129.098 74.1065 129.098C73.5185 129.098 72.9911 128.949 72.5245 128.65C72.0671 128.351 71.7078 127.931 71.4465 127.39C71.1945 126.849 71.0685 126.228 71.0685 125.528C71.0685 124.819 71.1945 124.198 71.4465 123.666C71.7078 123.134 72.0671 122.723 72.5245 122.434C72.9818 122.145 73.5091 122 74.1065 122C74.6198 122 75.0678 122.112 75.4505 122.336C75.8425 122.551 76.1411 122.859 76.3465 123.26V119.13H77.7605ZM74.4425 127.978C75.0585 127.978 75.5298 127.768 75.8565 127.348C76.1925 126.928 76.3605 126.331 76.3605 125.556C76.3605 124.781 76.1925 124.184 75.8565 123.764C75.5298 123.344 75.0585 123.134 74.4425 123.134C73.8265 123.134 73.3458 123.344 73.0005 123.764C72.6645 124.175 72.4965 124.763 72.4965 125.528C72.4965 126.293 72.6691 126.895 73.0145 127.334C73.3598 127.763 73.8358 127.978 74.4425 127.978ZM79.732 129V122.168H81.146V129H79.732ZM79.634 119.116H81.258V120.586H79.634V119.116ZM86.8046 122C88.4379 122 89.2546 122.919 89.2546 124.758V129H87.8406V124.828C87.8406 124.249 87.7239 123.825 87.4906 123.554C87.2666 123.283 86.9119 123.148 86.4266 123.148C85.8572 123.148 85.3999 123.325 85.0546 123.68C84.7092 124.035 84.5366 124.511 84.5366 125.108V129H83.1226V122.168H84.5086V123.26C84.7326 122.849 85.0452 122.537 85.4466 122.322C85.8479 122.107 86.3006 122 86.8046 122ZM97.545 122.168V128.454C97.545 129.499 97.265 130.288 96.705 130.82C96.1543 131.352 95.3377 131.618 94.255 131.618C93.667 131.618 93.107 131.539 92.575 131.38C92.0523 131.231 91.5857 131.011 91.175 130.722L91.609 129.7C92.057 129.989 92.4863 130.195 92.897 130.316C93.317 130.447 93.765 130.512 94.241 130.512C95.5197 130.512 96.159 129.863 96.159 128.566V127.488C95.963 127.899 95.6643 128.221 95.263 128.454C94.8617 128.678 94.395 128.79 93.863 128.79C93.2657 128.79 92.7337 128.65 92.267 128.37C91.8003 128.09 91.4363 127.693 91.175 127.18C90.923 126.667 90.797 126.074 90.797 125.402C90.797 124.73 90.9277 124.137 91.189 123.624C91.4503 123.111 91.8097 122.714 92.267 122.434C92.7337 122.145 93.2657 122 93.863 122C94.3857 122 94.843 122.112 95.235 122.336C95.6363 122.56 95.9397 122.877 96.145 123.288V122.168H97.545ZM94.199 127.67C94.8057 127.67 95.2817 127.469 95.627 127.068C95.9723 126.667 96.145 126.111 96.145 125.402C96.145 124.702 95.9723 124.151 95.627 123.75C95.291 123.339 94.815 123.134 94.199 123.134C93.583 123.134 93.0977 123.335 92.743 123.736C92.3977 124.137 92.225 124.693 92.225 125.402C92.225 126.111 92.4023 126.667 92.757 127.068C93.1117 127.469 93.5923 127.67 94.199 127.67ZM99.3612 127.334H101.027V129H99.3612V127.334ZM102.697 127.334H104.363V129H102.697V127.334ZM106.033 127.334H107.699V129H106.033V127.334Z",
    fill: "#676773"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8714_10391)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.889 54.3887L103.688 50.2368V28.9211L98.6201 26V65.7459L111.058 72.9162L113.41 59.5703L110.889 54.3887Z",
    fill: "#71A55C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.25 57.1714L99.048 53.0195V31.7038L93.981 28.7827V68.5287L106.419 75.6984L108.771 62.353L106.25 57.1714Z",
    fill: "#71A55C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6198 26.0001L93.981 28.7828L99.048 31.7039L103.687 28.9212L98.6198 26.0001Z",
    fill: "#95C27A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.688 50.2367L99.0488 53.0194L106.251 57.1713L110.89 54.3886L103.688 50.2367Z",
    fill: "#95C27A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.688 28.9211L99.0488 31.7038V53.0195L103.688 50.2368V28.9211Z",
    fill: "#65964F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.41 59.5704L108.771 62.3531L106.419 75.6985L111.058 72.9164L113.41 59.5704Z",
    fill: "#5E8B45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.25 57.1714L108.771 62.353L113.41 59.5703L110.889 54.3887L106.25 57.1714Z",
    fill: "#7DAF66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0729 30.9038C95.3197 30.7827 95.638 30.8038 95.9785 31C96.7765 31.46 97.4229 32.6936 97.4229 33.7557C97.4229 34.3271 97.235 34.7325 96.9373 34.913L50.0382 61.8444L48.1792 57.8352L95.0729 30.9038Z",
    fill: "#A3A4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6626 59.011C47.6626 60.0726 48.3095 61.3067 49.1069 61.7662C49.9043 62.2262 50.5507 61.738 50.5507 60.6759C50.5507 59.6143 49.9043 58.3808 49.1069 57.9208C48.3095 57.4608 47.6626 57.9494 47.6626 59.011Z",
    fill: "#787975"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.442 60.0288C103.442 61.5574 104.372 63.3331 105.521 63.9947C106.669 64.6563 107.599 63.9542 107.599 62.4255C107.599 60.8969 106.669 59.1212 105.521 58.4596C104.372 57.7974 103.442 58.5001 103.442 60.0288Z",
    fill: "#5E8B45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.814 51.1201L99.5448 46.9298L99.0625 47.1995L99.5448 48.9158L106.814 53.1066C107.224 53.3428 107.56 53.0898 107.56 52.5433C107.56 51.9968 107.224 51.3563 106.814 51.1201Z",
    fill: "#3B3C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.839 53.4001L107.323 53.1287L107.233 52.7152L106.704 52.9179L106.839 53.4001Z",
    fill: "#3B3C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.331 51.3897L99.0625 47.1995V49.1854L106.331 53.3762C106.742 53.6124 107.077 53.3595 107.077 52.813C107.077 52.267 106.742 51.6259 106.331 51.3897Z",
    fill: "#272826"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.06 60.4352C105.154 60.3903 105.271 60.3963 105.4 60.4709C105.705 60.6465 105.952 61.1174 105.952 61.5228C105.952 61.7428 105.878 61.8952 105.762 61.9633L103.336 63.3303L102.669 61.7784L105.06 60.4352Z",
    fill: "#A8A9A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.438 62.2419C102.438 62.6473 102.685 63.1181 102.99 63.2937C103.295 63.4694 103.542 63.2829 103.542 62.8775C103.542 62.4721 103.295 62.0008 102.99 61.8256C102.685 61.65 102.438 61.8364 102.438 62.2419Z",
    fill: "#8E8F8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.669 62.3942C102.669 62.6239 102.808 62.8904 102.98 62.9893C103.153 63.0893 103.292 62.9834 103.292 62.7542C103.292 62.525 103.153 62.2585 102.98 62.159C102.808 62.0596 102.669 62.165 102.669 62.3942Z",
    fill: "#373835"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9564 57.9995L72.3893 72.6622L97.9564 57.9995C98.6915 57.6411 99.6378 57.7022 100.652 58.2865C103.025 59.6546 104.948 63.3243 104.948 66.4833C104.948 68.1849 104.39 69.3903 103.504 69.927L63.7493 92.7097L58.2178 80.7827C58.2178 80.7827 97.8806 58.0373 97.9564 57.9995Z",
    fill: "#E0E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6821 84.2795C56.6821 87.4384 58.6056 91.1087 60.9783 92.4762C63.3511 93.8443 65.275 92.3924 65.275 89.233C65.275 86.0741 63.3511 82.4043 60.9783 81.0362C58.6056 79.6681 56.6821 81.1205 56.6821 84.2795Z",
    fill: "#CAD4E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4912 85.0775C57.4912 87.3986 58.9047 90.0948 60.6484 91.0997C62.3915 92.1051 63.805 91.0381 63.805 88.717C63.805 86.3959 62.3915 83.6991 60.6484 82.6943C58.9047 81.6894 57.4912 82.7564 57.4912 85.0775Z",
    fill: "#ADBDD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4292 85.8056C58.4292 87.3342 59.3598 89.1099 60.5075 89.7721C61.6557 90.4337 62.5868 89.7315 62.5868 88.2029C62.5868 86.6742 61.6557 84.8985 60.5075 84.2369C59.3598 83.5748 58.4292 84.2775 58.4292 85.8056Z",
    fill: "#99B0D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0162 86.4223C60.1104 86.3774 60.2273 86.3833 60.3567 86.4579C60.6609 86.6336 60.9078 87.1044 60.9078 87.5098C60.9078 87.7304 60.8336 87.8822 60.7188 87.9504L58.2925 89.3179L57.625 87.7655L60.0162 86.4223Z",
    fill: "#A8A9A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3945 88.2287C57.3945 88.6341 57.6414 89.1049 57.9462 89.2806C58.2504 89.4562 58.4973 89.2698 58.4973 88.8643C58.4973 88.4589 58.2504 87.9881 57.9462 87.8125C57.6414 87.6368 57.3945 87.8233 57.3945 88.2287Z",
    fill: "#8E8F8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.625 88.3818C57.625 88.611 57.7645 88.8775 57.9369 88.977C58.1088 89.0764 58.2482 88.971 58.2482 88.7418C58.2482 88.5121 58.1088 88.2456 57.9369 88.1467C57.7645 88.0467 57.625 88.1527 57.625 88.3818Z",
    fill: "#373835"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3374 48.9434C95.4316 48.8985 95.5485 48.9045 95.6779 48.979C95.9827 49.1542 96.2295 49.6255 96.2295 50.0309C96.2295 50.2509 96.1554 50.4034 96.0401 50.4715L93.6137 51.839L92.9468 50.2866L95.3374 48.9434Z",
    fill: "#A8A9A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7163 50.7493C92.7163 51.1553 92.9637 51.6261 93.2679 51.8017C93.5727 51.9774 93.8196 51.7909 93.8196 51.3855C93.8196 50.9801 93.5727 50.5088 93.2679 50.3331C92.9637 50.158 92.7163 50.3439 92.7163 50.7493Z",
    fill: "#8E8F8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9468 50.9028C92.9468 51.132 93.0862 51.3984 93.2581 51.4979C93.43 51.5968 93.5695 51.4914 93.5695 51.2622C93.5695 51.033 93.43 50.7666 93.2581 50.6671C93.0862 50.5676 92.9468 50.673 92.9468 50.9028Z",
    fill: "#373835"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2341 46.5076L62.6671 61.1703L88.2341 46.5076C88.9693 46.1492 89.9156 46.2097 90.9301 46.7946C93.3028 48.1627 95.2263 51.8324 95.2263 54.9919C95.2263 56.693 94.6681 57.8984 93.7819 58.4357L54.0276 81.2184L48.4961 69.2908C48.4961 69.2908 88.1589 46.5454 88.2341 46.5076Z",
    fill: "#CAD4E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.96 72.7875C46.96 75.9464 48.8834 79.6167 51.2567 80.9848C53.6294 82.3524 55.5529 80.9005 55.5529 77.741C55.5529 74.5821 53.6294 70.9124 51.2567 69.5443C48.8834 68.1762 46.96 69.6286 46.96 72.7875Z",
    fill: "#ADBDD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7681 73.5854C47.7681 75.9065 49.1815 78.6027 50.9247 79.6081C52.6684 80.613 54.0813 79.546 54.0813 77.2249C54.0813 74.9038 52.6684 72.2076 50.9247 71.2022C49.1815 70.1973 47.7681 71.2644 47.7681 73.5854Z",
    fill: "#99B0D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.707 74.3143C48.707 75.8424 49.6376 77.618 50.7858 78.2802C51.934 78.9418 52.8646 78.2391 52.8646 76.711C52.8646 75.1824 51.934 73.4067 50.7858 72.7445C49.6376 72.0829 48.707 72.7856 48.707 74.3143Z",
    fill: "#83A0C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2934 74.9303C50.3876 74.8854 50.5046 74.8914 50.634 74.966C50.9387 75.1411 51.1856 75.6125 51.1856 76.0179C51.1856 76.2379 51.1114 76.3903 50.9961 76.4584L48.5698 77.826L47.9028 76.2736L50.2934 74.9303Z",
    fill: "#A8A9A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6724 76.7367C47.6724 77.1421 47.9192 77.6129 48.224 77.7886C48.5282 77.9643 48.7751 77.7778 48.7751 77.3724C48.7751 76.967 48.5282 76.4962 48.224 76.3205C47.9192 76.1448 47.6724 76.3313 47.6724 76.7367Z",
    fill: "#8E8F8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9028 76.8898C47.9028 77.119 48.0423 77.3855 48.2142 77.485C48.3861 77.5844 48.5261 77.479 48.5261 77.2493C48.5261 77.0201 48.3861 76.7536 48.2142 76.6542C48.0423 76.5553 47.9028 76.6601 47.9028 76.8898Z",
    fill: "#373835"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.807 50.4066C102.054 50.2861 102.372 50.3066 102.713 50.5034C103.511 50.9628 104.157 52.1969 104.157 53.2585C104.157 53.8304 103.97 54.2353 103.672 54.4163L56.7731 81.3477L54.9136 77.3385L101.807 50.4066Z",
    fill: "#8E8F8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3979 78.5142C54.3979 79.5758 55.0443 80.8093 55.8417 81.2693C56.6397 81.7288 57.2861 81.2412 57.2861 80.179C57.2861 79.1174 56.6397 77.8839 55.8417 77.4239C55.0443 76.9639 54.3979 77.452 54.3979 78.5142Z",
    fill: "#787975"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.801 84.4894L51.5988 80.3375V59.0218L46.5317 56.1007V95.8467L58.9693 103.017L61.3215 89.671L58.801 84.4894Z",
    fill: "#71A55C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1618 87.2719L46.9596 83.12V61.8043L41.8926 58.8827V98.6292L54.3296 105.799L56.6824 92.453L54.1618 87.2719Z",
    fill: "#71A55C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8827 87.7055L48.6841 84.7087V101.817L53.8968 104.822L56.1077 92.2801L53.8827 87.7055Z",
    fill: "#E0E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7014 91.0367L49.4604 88.5918V86.2496L53.7014 88.6945V91.0367Z",
    fill: "#272826"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7014 91.8416L49.4604 89.3973V88.9043L53.7014 91.3492V91.8416Z",
    fill: "#272826"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4021 90.4984L49.7588 88.3984V86.7881L53.4021 88.8886V90.4984Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5314 56.1007L41.8926 58.8829L46.9596 61.8045L51.5985 59.0218L46.5314 56.1007Z",
    fill: "#95C27A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5988 80.3374L46.96 83.1201L54.1621 87.272L58.801 84.4893L51.5988 80.3374Z",
    fill: "#95C27A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7099 81.026L48.2192 83.1201L54.0502 86.4136L57.5408 84.3195L51.7099 81.026Z",
    fill: "#E0E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5988 59.0217L46.96 61.8044V83.1201L51.5988 80.3374V59.0217Z",
    fill: "#65964F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3212 89.6708L56.6823 92.4529L54.3296 105.799L58.969 103.017L61.3212 89.6708Z",
    fill: "#5E8B45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1621 87.2721L56.6827 92.4532L61.3215 89.671L58.801 84.4894L54.1621 87.2721Z",
    fill: "#7DAF66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0322 90.3731L43.2246 89.331V86.0212L45.0322 87.0634V90.3731Z",
    fill: "#E0E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7724 88.7194L43.4829 87.9762V86.5281L44.7724 87.2713V88.7194Z",
    fill: "#272826"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0312 87.0632L46.265 86.3221V89.6324L45.0312 90.3729V87.0632Z",
    fill: "#C8D2DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4584 85.2802L43.2246 86.0212L45.0322 87.0634L46.2659 86.3223L44.4584 85.2802Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1249 82.0671L51.8245 82.8168L51.5474 82.6568L52.8477 81.9076L53.1249 82.0671Z",
    fill: "#3B3C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9293 83.3692C51.9293 83.6854 51.4729 83.9416 50.9104 83.9416C50.3474 83.9416 49.8916 83.6854 49.8916 83.3692C49.8916 83.053 50.3474 82.7968 50.9104 82.7968C51.4729 82.7968 51.9293 83.053 51.9293 83.3692Z",
    fill: "#3B3C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1006 82.7968V83.2719C50.1006 83.5232 50.4628 83.7276 50.9105 83.7276C51.3576 83.7276 51.7203 83.5232 51.7203 83.2719V82.7968H50.1006Z",
    fill: "#D63739"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7203 82.8175C51.7203 83.0688 51.3576 83.2721 50.9105 83.2721C50.4628 83.2721 50.1006 83.0688 50.1006 82.8175C50.1006 82.5656 50.4628 82.3618 50.9105 82.3618C51.3576 82.3618 51.7203 82.5656 51.7203 82.8175Z",
    fill: "#E15F5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4501 83.4218L54.1497 84.1715L53.8726 84.0115L55.1723 83.2623L55.4501 83.4218Z",
    fill: "#3B3C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2554 84.7238C54.2554 85.04 53.7991 85.2968 53.2366 85.2968C52.6736 85.2968 52.2178 85.04 52.2178 84.7238C52.2178 84.4081 52.6736 84.1514 53.2366 84.1514C53.7991 84.1514 54.2554 84.4081 54.2554 84.7238Z",
    fill: "#3B3C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4263 84.1514V84.627C52.4263 84.8784 52.7884 85.0822 53.2361 85.0822C53.6833 85.0822 54.046 84.8784 54.046 84.627V84.1514H52.4263Z",
    fill: "#D63739"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.046 84.1721C54.046 84.4234 53.6833 84.6272 53.2361 84.6272C52.7884 84.6272 52.4263 84.4234 52.4263 84.1721C52.4263 83.9207 52.7884 83.7169 53.2361 83.7169C53.6833 83.7169 54.046 83.9207 54.046 84.1721Z",
    fill: "#E15F5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.827 50.7482C105.074 50.6277 105.392 50.6482 105.732 50.8444C106.53 51.3044 107.177 52.5379 107.177 53.5996C107.177 54.1714 106.989 54.5768 106.691 54.7574L59.7921 81.6893L57.9331 77.6801L104.827 50.7482Z",
    fill: "#A3A4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4165 78.8552C57.4165 79.9168 58.0634 81.1508 58.8608 81.6103C59.6582 82.0703 60.3052 81.5822 60.3052 80.5206C60.3052 79.4584 59.6582 78.2249 58.8608 77.7649C58.0634 77.3054 57.4165 77.7935 57.4165 78.8552Z",
    fill: "#787975"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8825 78.7359L51.6137 74.545L51.1309 74.8153L51.6137 76.5315L58.8825 80.7223C59.2928 80.9586 59.6285 80.705 59.6285 80.1591C59.6285 79.6126 59.2928 78.9726 58.8825 78.7359Z",
    fill: "#3B3C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9071 81.0157L59.3914 80.7444L59.3022 80.3314L58.772 80.5336L58.9071 81.0157Z",
    fill: "#3B3C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4002 79.0055L51.1309 74.8152V76.8011L58.4002 80.9919C58.8105 81.2287 59.1461 80.9752 59.1461 80.4287C59.1461 79.8822 58.8105 79.2422 58.4002 79.0055Z",
    fill: "#272826"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9609 79.0064C54.9609 79.6545 55.355 80.4069 55.8417 80.6875C56.3284 80.968 56.723 80.6702 56.723 80.0226C56.723 79.3745 56.3284 78.6215 55.8417 78.341C55.355 78.0604 54.9609 78.3588 54.9609 79.0064Z",
    fill: "#272826"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.7391 33.3925L92.8271 34.8487L100.188 53.4649L60.4239 76.2498L53.1124 57.7773L51.1045 56.1552L90.7391 33.3925Z",
    fill: "#E0E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0453 59.0789C52.3441 59.4189 52.6635 59.7698 52.9537 60.1406C53.213 59.9427 53.3733 59.5568 53.3733 59.0287C53.3733 57.9665 52.7269 56.7335 51.9295 56.2735C51.1391 55.8179 50.4998 56.2946 50.4873 57.3352C51.0113 57.9119 51.5305 58.4941 52.0453 59.0789Z",
    fill: "#A3A4A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2456 34.5391C90.2456 35.6012 90.892 36.8342 91.6899 37.2942C92.4874 37.7537 93.1337 37.2661 93.1337 36.2039C93.1337 35.1423 92.4874 33.9088 91.6899 33.4488C90.892 32.9888 90.2456 33.4769 90.2456 34.5391Z",
    fill: "#E0E8F0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8714_10391",
    x: 0,
    y: 0,
    width: 156,
    height: 156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.403922 0 0 0 0 0.886275 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8714_10391"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8714_10391",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8714_10391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 80,
    fill: "white",
    transform: "translate(42 26)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderLogo);
export default __webpack_public_path__ + "static/media/LoaderLogo.2466820cb4c98618a8982e3228ffa40b.svg";
export { ForwardRef as ReactComponent };